module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.0-132.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.0.md
// module id = 534
// module chunks = 274